import { Component, OnInit, Input, ViewChild } from '@angular/core';  
import { MessageService } from 'primeng/api';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { EffluentwatermeterService } from '../../services/effluentwatermeter.services';
import { EffluentwatermeterModel } from '../../modles/effluentwatermeter.model';
import { Parameter } from '../../../admin/models/parameter.model';
@Component({
  selector: 'app-list-effluent',
  templateUrl: './list-effluent.component.html',
  styleUrls: ['./list-effluent.component.css']
})
export class ListEffluentComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  dtOptions: any = {};
  effwaterlist:Array<EffluentwatermeterModel>=[];
  dtTrigger: Subject<any> = new Subject();
  departments: Array<Parameter>;
  constructor( private effservice: EffluentwatermeterService, private messageService: MessageService) {
  }

  ngOnInit() {
    this.effwaterlist=[];
    this.retrieveeffdetails();
    this.dtOptions = {
      dom: 'Bfrtip',
      searching: true,
      "language": {
        "emptyTable": "No data available"
      },  
      buttons: [
        {
          extend: 'print',
          text: '  <i class="fa fa-print"></i> ',
          titleAttr: 'Print'
        },
        {
          extend: 'pdf',
          title: 'Effluent Master',
          filename: 'effluent_aster-' + this.formatDate(new Date()),
          exportOptions: {
            columns: [0, 1, 2, 3, 4]
          },
          text: '<i class="fa fa-file-pdf-o"></i> ',
          orientation: 'landscape',
          titleAttr: 'Pdf'

        }, {
          extend: 'excel',
          title: 'Effluent Master',
          filename: 'effluent_aster-' + this.formatDate(new Date()),
          exportOptions: {
            columns: [0, 1, 2, 3, 4]
          },
          text: '<i class="fa fa-file-excel-o"></i> ',
          titleAttr: 'Excel'
        }]


    };
    this.effservice.EffluentwatermeterreatedObservable.subscribe((resp: boolean) => {
      if (resp) {
        this.retrieveeffdetails();
      }
    });
  }
  retrieveeffdetails() {
    this.effservice.getallEffluentwatermeterList().subscribe((resp: any) => {
        this.effwaterlist = resp.EffluentMasterlist;
        this.rerender();
    });
  }
  editEff(effId: number) {
    this.effservice.editEffluentwatermeterRequest(effId);
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  
  updateStatus(effData: EffluentwatermeterModel) {
    effData.Status = effData.Status ? false : true;
    this.effservice.addEffluentwatermeter(effData).subscribe((response: any) => {
      this.messageService.add({ severity: 'success', summary: 'Water Effluent update successfully', detail: '', sticky: false });
    });

  }
  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
}
